import React, { Component } from 'react';

class AddCheckbox extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      id: this.props.id,
      staff_data: this.props.staff_data,
      checked: false,
    };
  }

  handleCheckboxChange(name, event) {
    // valor selecionado. Valor são true e false
    var value = event.target.checked;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = value;
    }
    this.setState(change);
    if (value === false) {
      this.props.UnmarkCheckboxId(this.state.staff_data);
    } else {
      this.props.markedCheckboxId(this.state.staff_data);
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined') {
      this.setState({id: newProps.id, staff_data: newProps.staff_data});
    }
    var verify_checked = false;
    if (Array.isArray(newProps.checkbox_marked_ids)) {
      Object.keys(newProps.checkbox_marked_ids).map(function(k) {
        if(newProps.checkbox_marked_ids[k] === newProps.id) {
          verify_checked = true;
        }
      });
    }


    if (verify_checked) {
      this.setState({checked: true});
    } else {
      this.setState({checked: false});
    }

  }

  render() {
    return (
<div>
  <input
    name="checked"
    type="checkbox"
    checked={this.state.checked}
    onChange={this.handleCheckboxChange.bind(this, 'checked')} />
</div>
    );
  }
}

export default AddCheckbox;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/AddCheckbox.js